import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import About from './About';
import Owner from './Owner';
import coffe from './coffe.jpg';
import tea from './tea.jpg';
import dessert from './dessert.jpg';
import Greet from './Greet';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Modern Navbar */}
        <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top">
          <div className="container">
            <Link className="navbar-brand" to="/">
              ☕ Campus Grind
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about">About</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/owner">Owner</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link btn btn-outline-brown ms-lg-3" to="/greet">Greet</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={
            <>
              {/* Hero Section */}
              <header className="hero" style={{ 
                backgroundImage: 'url(https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080)', 
                backgroundSize: 'cover' 
              }}>
                <div className="hero-overlay"></div>
                <div className="container text-white text-center">
                  <h1 className="display-2 fw-bold">Campus Grind</h1>
                  <p className="lead fs-3">Where every bean tells a story.</p>
                  <a href="#menu" className="btn btn-warning btn-lg mt-4 px-5 py-3 fw-bold rounded-pill">Explore Menu</a>
                </div>
              </header>

              {/* Menu Section */}
              <section id="menu" className="menu-section container">
                <div className="text-center mb-5">
                  <h2 className="display-4">Our Signature Menu</h2>
                  <div className="mx-auto" style={{width: '60px', height: '4px', backgroundColor: '#f0ad4e'}}></div>
                </div>
                
                <div className="row g-4">
                  <div className="col-md-4">
                    <div className="menu-card">
                      <img src={coffe} alt="Coffee" className="w-100" />
                      <div className="menu-card-body">
                        <h3>Premium Coffee</h3>
                        <p className="text-muted">Hand-picked beans, roasted to perfection by our expert baristas.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="menu-card">
                      <img src={tea} alt="Tea" className="w-100" />
                      <div className="menu-card-body">
                        <h3>Artisan Tea</h3>
                        <p className="text-muted">Refreshing herbal blends and classic leaves from around the world.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="menu-card">
                      <img src={dessert} alt="Desserts" className="w-100" />
                      <div className="menu-card-body">
                        <h3>Homemade Pastries</h3>
                        <p className="text-muted">Daily baked desserts that pair perfectly with your favorite drink.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          } />
          
          <Route path="/about" element={<About />} />
          <Route path="/owner" element={<Owner />} />
          <Route path="/greet" element={<Greet />} />
        </Routes>

        <footer className="text-center">
          <div className="container">
            {/* CTF Flag Hidden properly in code */}
            <div className="d-none">CyberCamp{'{G0t_th3_Fl4g}'}</div>
            <p className="mb-0">© 2026 Campus Grind Cafe</p>
            <small className="text-muted">Sazidul Islam</small>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;